
import MobileAppImg from "../images/mobileApp.png";
import BachelorApp from "../images/image3.png";
import FallImg from "../images/image5.png";
import ChatbotImg from "../images/image6.png";
import MedicalImg from "../images/image7.png";





export const Bio = {
  name: "Laaraj Imane",
  roles: [
    "Full Stack Developer",
    "Android Developer",
    "AI Engineer",
    "Programmer",
  ],
  description:

    "Welcome to my professional portfolio. I am a motivated and versatile individual, always eager to take on new challenges . I am a dedicated web developer passionate about crafting seamless user experiences and integrating innovative artificial intelligence solutions.",
  github: "https://github.com/LaarajImane",
  resume:
    "https://drive.google.com/file/d/1EH4pAatcWM5RTPBIK-pRa2GT8dhj-vT1/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/imane-laaraj22/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Angular",
        image:
          "https://angular.io/assets/images/logos/angular/angular.svg",
      },
      {
        name: "Tailwind CSS",
        image:
          "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
        
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Spring Boot",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/spring/spring-original-wordmark.svg",
      },
      
    ],
  },
  {
    title: "Android",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Kotlin",
        image:
          "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
      },
      {
        name: "XML",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
      },
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
    ],
  },
  {
    
      title: "AI & Machine Learning",
      
      skills: [
    
        {
          name: "TensorFlow",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/2/2d/Tensorflow_logo.svg",
        },
        {
          name: "Keras",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/a/ae/Keras_logo.svg",
        },
        {
          name: "PyTorch",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/1/10/PyTorch_logo_icon.svg",
        },
        {
          name: "Scikit-learn",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/0/05/Scikit_learn_logo_small.svg",
        },
        {
          name: "OpenCV",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/3/32/OpenCV_Logo_with_text_svg_version.svg",
        },
      ],
    },
    
  
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
      },
      
      {
        name: "IntelliJ IDEA",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/1/1c/IntelliJ_IDEA_Icon.svg",
      },
    ],
  },
];

export const experiences = [
   
  {
    id: 0,
    img: "https://th.bing.com/th/id/OIP.K_5TQlKbuvx26E0KkU-1oAAAAA?w=80&h=80&c=1&bgcl=ec2144&r=0&o=7&cb=thwsc5&pid=ImgRC&rm=3", // tu peux remplacer par le logo de Stryve Maroc
    role: "AI & Software Engineering Intern",
    company: "Stryve Maroc",
    date: "2025",
    desc: "In 2025, I worked with Stryve Maroc on the development of an AI-powered cloud platform aimed at transforming how users interact with and retrieve information from their uploaded files. The project utilized Artificial Intelligence to extract key content and features from documents, enabling a deeper understanding of file structure and context. A core component of the system was the implementation of an intelligent search engine capable of interpreting user queries semantically to locate relevant information within files quickly and accurately. Additionally, I contributed to the integration of a smart chatbot that allowed users to engage in natural language conversations with their files—asking questions, requesting summaries, or retrieving specific insights in real time",
    skills: [
      "Laravel",
      "PHP",
      "Artificial Intelligence",
      "Chatbot Development",
      "AI-powered Automation"
    ],
  }, 
  
  {
    id: 2,
    img: "https://www.3dsmartfactory.csit.ma/images/1st-logo.png", // remplacer par le logo de 3D Factory Maroc
    role: "AI & Fullstack Development Intern",
    company: "3D Factory Maroc",
    date: "2025",
    desc: "In 2025, I contributed to the development of an intelligent medical appointment assistant at 3D Factory Maroc, aimed at improving access to healthcare through smart digital solutions. The platform allows users to input their location and medical needs (such as specialty or name of doctor), then leverages a database of medical centers to recommend the most suitable appointments based on proximity, real-time availability, and priority level. From a technical perspective, the project was built using Spring Boot for the backend and Angular for the frontend, ensuring a scalable, secure, and user-friendly architecture. The integration of geocoding and mapping APIs enabled precise location-based search, while an AI-powered chatbot provided patients with interactive assistance and personalized guidance.",
    skills: [
      "Spring Boot",
      "Angular",
      "Artificial Intelligence (Chatbot)",
      "Geocoding with Maps",
      "Fullstack Development"
    ],
  },
  {
    id: 1,
    img: "https://th.bing.com/th/id/OIP.d3izGEdphTKI-lQpQ52KQgHaD9?w=80&h=80&c=1&bgcl=5a70fe&r=0&o=7&cb=thwsc5&pid=ImgRC&rm=3",
    company: "Alidantek",
    date: "Final Year Internship | 2023",
    desc: "As part of my academic journey, I had the opportunity to complete a two-month internship at Alidantek, where I contributed to the development of a web application for automated diagnostics designed to help companies efficiently assess the skills and performance of their employees. The project’s main goal was to create an administrative dashboard that enables company administrators to design and manage customized quizzes to evaluate competencies, generate detailed analytics, and provide employees with personalized feedback highlighting their strengths and areas for improvement.",
    skills: [
      "Next.js",
      "Express.js",
      "JavaScript",
      "Web Development",
      "Frontend & Backend"
    ],
  }, 

];

export const education = [
  {
    id: 0,
    img: "https://imgs.search.brave.com/rzQuSk6XZpB4UwX18k7ChFFXMI2Xl6b15xvakE4wsm8/rs:fit:32:32:1:0/g:ce/aHR0cDovL2Zhdmlj/b25zLnNlYXJjaC5i/cmF2ZS5jb20vaWNv/bnMvYmIzYWU2M2Y1/ZDc1ZWI5YzA5Y2Nj/YWE0MmZlMzQzODYy/NWNkMjllMGEyZTJk/YzEzNmIwMTBjYWVk/NzZiYWFlOC93d3cu/ZnN0Zy1tYXJyYWtl/Y2guYWMubWEv", // tu peux remplacer par le logo de la FST Marrakech
    school: "Faculté des sciences et techniques | Marrakech",
    date: "2024 - 2025",
    grade: "Master Student",
    desc: "Currently in the final year of the Master's program in Artificial Intelligence and Computer Engineering.",
    degree: "Master's Degree in Artificial Intelligence & Computer Engineering",
  },
  {
    id: 1,
    img: "https://imgs.search.brave.com/rzQuSk6XZpB4UwX18k7ChFFXMI2Xl6b15xvakE4wsm8/rs:fit:32:32:1:0/g:ce/aHR0cDovL2Zhdmlj/b25zLnNlYXJjaC5i/cmF2ZS5jb20vaWNv/bnMvYmIzYWU2M2Y1/ZDc1ZWI5YzA5Y2Nj/YWE0MmZlMzQzODYy/NWNkMjllMGEyZTJk/YzEzNmIwMTBjYWVk/NzZiYWFlOC93d3cu/ZnN0Zy1tYXJyYWtl/Y2guYWMubWEv",
    school: "Faculté des sciences et techniques | Marrakech",
    date: "2023 - 2024",
    grade: "Bachelor Student",
    desc: "Completed the Bachelor's degree in Science and Technology, specializing in Distributed Computer Systems.",
    degree: "Bachelor's Degree in Science & Technology: Distributed Computer Systems",
  },
  {
    id: 2,
    img: "https://imgs.search.brave.com/rzQuSk6XZpB4UwX18k7ChFFXMI2Xl6b15xvakE4wsm8/rs:fit:32:32:1:0/g:ce/aHR0cDovL2Zhdmlj/b25zLnNlYXJjaC5i/cmF2ZS5jb20vaWNv/bnMvYmIzYWU2M2Y1/ZDc1ZWI5YzA5Y2Nj/YWE0MmZlMzQzODYy/NWNkMjllMGEyZTJk/YzEzNmIwMTBjYWVk/NzZiYWFlOC93d3cu/ZnN0Zy1tYXJyYWtl/Y2guYWMubWEv",
    school: "Faculté des sciences et techniques | Marrakech",
    date: "2021 - 2023",
    grade: "Undergraduate Studies",
    desc: "Completed Diplôme d'études universitaires scientifiques (DEUS) in Mathematics, Computer Science, Physics, and Chemistry.",
    degree: "DEUS - Mathematics, Computer Science, Physics, Chemistry",
  },
  {
    id: 3,
    img: "https://tse1.mm.bing.net/th/id/OIP.MCgy4qx8moM8usj908VP8gHaHa?r=0&rs=1&pid=ImgDetMain&o=7&rm=3",
    school: "Lycée ATLAS | Idouirane Chichaoua",
    date: "2021",
    grade: "Very Good",
    desc: "Completed Baccalauréat in Physics and Chemistry with high honors.",
    degree: "Baccalauréat - Physics & Chemistry",
  },
];


export const projects = [
  {
    id: 0,
    title: "Smart Attendance Mobile App",
    date: "2024",
    description:
    "To address the challenges of manual attendance tracking in universities—such as time consumption, human errors, and lack of integration with academic systems—we designed an intelligent mobile application that automates student attendance management through facial recognition technology. This solution allows the system to automatically detect and record student presence in real time, eliminating the need for paper-based or manual entry methods. It also includes dedicated interfaces for both administrators and instructors, enabling efficient management of academic structures such as departments, modules, and teaching staff. By integrating artificial intelligence and mobile technologies, the platform ensures faster, more reliable, and more secure attendance tracking while improving data accuracy and reducing administrative workload.",
    image: MobileAppImg, // remplacer par image réelle
    tags: ["Android (Kotlin)", "Python", "OpenCV", "LBPH", "Face Recognition"],
    category: "android app",
    github: "https://github.com/LaarajImane/AbsenceAI.git",
    webapp: "https://drive.google.com/file/d/18-g0HWWyd3Z7q12rSOGMrOE0t1SV0-0D/view?usp=sharing", // remplacer par vidéo réelle
  },
  {
    id: 1,
    title: "Final Year Internship Web App | Alidantek",
    date: "2025",
    description:
    "I created a web application for automated diagnostics that enables companies to efficiently evaluate their employees’ skills and performance through interactive and data-driven assessments. The platform provides an admin interface where company managers can design customized quizzes, define evaluation criteria, and generate detailed reports highlighting each employee’s strengths and areas for improvement. By combining Next.js for the frontend and Express.js for the backend, the application delivers a smooth and dynamic user experience while ensuring secure data management. This project enhanced my expertise in full-stack web development and AI-assisted analysis, demonstrating my ability to build intelligent solutions that improve organizational decision-making and employee development.",
    image: BachelorApp,
    tags: ["Next.js", "Express.js", "JavaScript", "Web Development"],
    category: "web app",
    github: "https://github.com/LaarajImane/QuizAppStage.git",
    webapp: "https://drive.google.com/file/d/1ZdvJjTJ-0U-HLFRKfIURR8MqqMcj6F3J/view?usp=sharing",
  },
  {
    id: 2,
    title: "FAQ Chatbot",
    date: "2025",
    description:
    "I developed an intelligent FAQ chatbot designed to provide instant and accurate answers to users’ questions about specific topics or products by leveraging Natural Language Processing (NLP) techniques. The chatbot is capable of understanding user intent, extracting key information from queries, and delivering context-aware responses in real time. Built with a focus on user experience, it offers a natural and conversational interface that improves accessibility and reduces the need for manual customer support. Through the integration of NLP models and an optimized knowledge base, the system continuously learns and refines its responses to ensure higher accuracy and relevance over time. This project strengthened my skills in AI-driven dialogue systems, language understanding, and intelligent automation, showcasing my ability to combine technical innovation with user-centered design.",
    image: ChatbotImg,
    tags: ["Django", "NLP", "SpaCy", "Python", "AI"],
    category: "ai app",
    github: "https://github.com/LaarajImane/ChatbotFags.git",
    webapp: "https://drive.google.com/file/d/1mNUeyGuQShEoljXuK5LJuJDPS1Z8Gz5S/view?usp=sharing",
  },
  {
    id: 3,
    title: "Fall Detection Mobile App",
    date: "2025",
    description:
    " With the rapid aging of the population, falls have become one of the most common and dangerous domestic accidents among the elderly, often leading to serious injuries, loss of autonomy, and high hospitalization costs. Existing solutions remain limited, as manual supervision is costly and difficult to sustain over long periods. This project aimed to develop an intelligent mobile application that provides a non-intrusive, real-time system capable of detecting falls automatically, without requiring constant human monitoring. The solution combines computer vision and machine learning techniques to analyze live video streams and detect abnormal behavior indicative of a fall. The system uses a camera to monitor the environment in real time, applies image processing to enhance video quality and extract relevant features, and employs a pose estimation model to analyze human posture. When a fall is detected, the application automatically triggers an alert to notify caregivers or responsible personnel, thereby enhancing the safety and autonomy of elderly individuals.",
    image: FallImg,
    tags: ["Python", "Mediapipe", "OpenCV", "WebSocket", "Kotlin"],
    category: "android app",
    github: "https://github.com/LaarajImane/Fall-detection.git",
    webapp: "https://drive.google.com/file/d/1UfHkJm8KIWqjYmbewaWZEZWVgVZrEt5e/view?usp=sharing",
  },
  {
    id: 4,
    title: "Audio Transcription App",
    date: "2025",
    description:
      "Developed and deployed a tool that converts audio recordings into text efficiently.",
      image: "https://imgs.search.brave.com/3fZP234vYWju1ok6aK5sfVXtERb-sTv0GYrAI61QW38/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9tZWRp/YS5nZXR0eWltYWdl/cy5jb20vaWQvMTMy/OTcyMjAyMi92ZWN0/b3IvcG9kY2FzdC1h/dWRpby13YXZlcy1i/YWNrZ3JvdW5kLmpw/Zz9zPTYxMng2MTIm/dz0wJms9MjAmYz1p/Z05XYUpuQjlJOGJu/QXc1dmtUOV96VmE0/M3JySU41Uk14am00/eFNuRldrPQ",
      tags: ["Spring Boot", "Spring AI", "React", "Java", "Web App"],
    category: "web app",
    github: "#",
    webapp: "#",
  },
  {
    id: 5,
    title: "Medical Finder & Appointment Web App",
    date: "2025",
    description:
      "Developed an innovative web application that connects patients with nearby doctors, allowing them to search by specialty, location, or name, and book appointments online. The platform integrates the OpenRouteService (ORS) API based on OpenStreetMap to estimate distances and travel times, ensuring efficient and user-friendly navigation. Built with Spring Boot for the backend and Angular for the frontend, the app combines robustness and reactivity. It also includes email confirmation for appointment bookings, providing smooth and reliable communication between patients and healthcare professionals.",
    image: MedicalImg,
    tags: ["Spring Boot", "Angular", "OpenRouteService", "Tailwind CSS", "Angular Material", "Web Development"],
    category: "ai app",
    github: "https://github.com/fatimaezzahraerabia/BackendMedAssistant.git",
    webapp: "https://drive.google.com/file/d/1XJ4nhzdWRXcFTl6D2Q-8K00lesoZbJJ4/view?usp=sharing",  
  }
  
];


export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
